import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import GalleryForm from './GalleryForm';
import GalleryFormSerializer from './../../services/GalleryFormSerializer';
import * as galleryActions from '../../actions/gallery/galleryActions';
import * as modalActions from '../../actions/common/modalActions';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import {toastr} from 'react-redux-toastr';
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";

class GalleryFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];
        if (this.isUpdate()) {
            actions.push(this.props.actions.getGallery(this.props.match.params.id))
        }

        return actions;
    }

    componentDidMount() {
        if (!this.isUpdate()) {
            this.props.actions.resetGallery()
        }
    }

    submit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let fields = GalleryFormSerializer.serialize(formFields);

        if(this.isUpdate()) {
            this.props.actions.updateGallery(fields, formFields.id)
                .then(() => {
                    this.props.actions.hideSubmitButtonSpinner();
                    toastr.success('Galleri opdateret');
                    this.context.router.history.push('/galleri/vis/' + formFields.id);
                })
                .catch((e) => {
                    console.log(e);
                    toastr.error(e.message);
                    this.props.actions.hideSubmitButtonSpinner()
                });
        } else {
            this.props.actions.saveGallery(fields)
                .then(() => {
                    this.props.actions.hideSubmitButtonSpinner();
                    toastr.success('Galleri oprettet');
                    this.context.router.history.push('/galleri');
                })
                .catch((e) => {
                    toastr.error(e.message);
                    this.props.actions.hideSubmitButtonSpinner()
                });
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    redirect() {
        this.context.router.history.push('/galleri');
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.isUpdate() ? 'Opdater galleri' : 'Opret galleri'} {/*this.props.intl.formatMessage(messages.gallery)*/}</h1>
                                <GalleryForm
                                    initialValues={this.props.gallery}
                                    onSubmit={this.submit}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate()}
                                />
                            </div>
                        </div>
                    </div>
                    <ResetFormModal
                        modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                        modalContent={
                            <p>
                                <FormattedMessage
                                    id="reset.modal.message"
                                    defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                                />
                            </p>}
                        confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                        closeText={this.props.intl.formatMessage(messages.buttonNo)}
                        handleConfirm={() => {this.confirmReset()}}
                    />
                </div>
            </WithResolvedPromises>
        );
    }
}

GalleryFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let gallery = GalleryFormSerializer.unserialize(state.gallery);

    return {
        gallery,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...galleryActions,
            ...submitButtonActions,
            ...modalActions,
        }, dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GalleryFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryFormContainer.jsx